import { defineMessages, useIntl } from 'react-intl';

import { Button } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsChooseNewButton = (props: Props) => {
  const { count, palette, disabled, onPress } = props;

  const { formatMessage } = useIntl();

  // ─── Derived ─────────────────────────────────────────────────────────

  const message = count === 1 ? messages.chooseNewIngredient : messages.chooseNewIngredients;
  const label = formatMessage(message);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Button
      size="large-wide"
      palette={palette}
      disabled={disabled}
      onPress={onPress}
      accessibilityLabel={label}
      accessibilityRole="button"
    >
      {label}
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  chooseNewIngredient: {
    defaultMessage: 'Choose a new ingredient',
    description: 'Add To Bag | Unavailable ingredients | Choose new ingredient CTA (single)',
  },
  chooseNewIngredients: {
    defaultMessage: 'Choose new ingredients',
    description: 'Add To Bag | Unavailable ingredients | Choose new ingredients CTA (multiple)',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  count: number;
  palette: 'primary' | 'secondary';
  disabled: boolean;
  onPress: () => void;
};
